/** New session (2.D deliverable 7): a title, then one `sessions.create`. */

import { tid } from '@codex/contracts';
import { Button, TextField } from '@codex/ui';
import { useState } from 'react';
import { useCreateSession } from '../writes.js';

export function NewSession({
  nextNumber,
  onCreated,
  label = 'New session',
}: {
  nextNumber: number;
  onCreated: (sessionId: string) => void;
  label?: string;
}): React.JSX.Element {
  const [open, setOpen] = useState(false);
  const [title, setTitle] = useState('');
  const [message, setMessage] = useState<string | null>(null);
  const create = useCreateSession();
  const fallback = `Session ${nextNumber}`;

  if (!open) {
    return (
      <Button
        icon="plus"
        {...tid('sessions.tonight.new')}
        onClick={() => {
          setTitle(fallback);
          setMessage(null);
          setOpen(true);
        }}
      >
        {label}
      </Button>
    );
  }
  const submit = async () => {
    const trimmed = title.trim();
    if (trimmed === '') {
      setMessage('Enter a title.');
      return;
    }
    const out = await create.run({ title: trimmed, status: 'planned' });
    if (out.ok) {
      setOpen(false);
      onCreated(out.data.document.id);
    } else setMessage(out.message);
  };
  return (
    <form
      className="cx-tonight__new"
      aria-label="New session"
      onSubmit={(event) => {
        event.preventDefault();
        if (!create.pending) void submit();
      }}
    >
      <TextField
        label="Title"
        value={title}
        required
        autoFocus
        onChange={(event) => setTitle(event.currentTarget.value)}
      />
      <Button type="submit" variant="primary" busy={create.pending}>
        Create
      </Button>
      <Button onClick={() => setOpen(false)}>Cancel</Button>
      {message !== null && (
        <p className="cx-tonight__error" role="alert">
          {message}
        </p>
      )}
    </form>
  );
}
